import { Routes } from '@angular/router';
import { TendersListComponent } from '@tenders/tenders-list/tenders-list.component';
import { TendersDetailComponent } from '@tenders/tenders-detail/tenders-detail.component';

export const TendersRoutes: Routes = [
  {
    path: '',
    component: TendersListComponent,
    data: { titleKey: 'routes.tenders' },
  },
  {
    path: ':tenderId',
    component: TendersDetailComponent,
    data: { titleKey: 'routes.tenderDetails' },
  },
];
